import React, { useEffect, useState } from 'react';
import { Box, Heading, Page, PageContent, Text } from 'grommet';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { API } from '@enrich/shared-lib';
import QueryString from 'qs';

export const ActiveStudentsMenu = () => {
    const user = useOutletContext();
    const { schoolSlug } = useParams();
    const navigate = useNavigate();
    const school = user.school;
    const [matchedCurrentCount, setMatchedCurrentCount] = useState(0);
    const [matchedFutureCount, setMatchedFutureCount] = useState(0);
    const [notMatchedCount, setNotMatchedCount] = useState(0);

    useEffect(() => {
        let isActive = true;

        (async () => {
            const [current, future, unmatched] = await Promise.all([
                loadMatchedCurrentCount(school.id),
                loadMatchedFutureCount(school.id),
                loadNotMatchedCount(school.id),
            ]);

            if (isActive) {
                setMatchedCurrentCount(current);
                setMatchedFutureCount(future);
                setNotMatchedCount(unmatched);
            }
        })();

        return () => {
            isActive = false;
        };
    }, [school.id]);

    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent gap="medium">
                <Heading level="3">Active Students</Heading>
                <Box direction="row" gap="medium" wrap>
                    <SubCard
                        label="Matched with current opportunities"
                        value={matchedCurrentCount}
                        onClick={() =>
                            navigate(
                                `/${schoolSlug}/active-students/matched-current`,
                            )
                        }
                    />
                    <SubCard
                        label="Matched with future opportunities"
                        value={matchedFutureCount}
                        onClick={() =>
                            navigate(
                                `/${schoolSlug}/active-students/matched-future`,
                            )
                        }
                    />
                    <SubCard
                        label="Not Matched"
                        value={notMatchedCount}
                        onClick={() =>
                            navigate(
                                `/${schoolSlug}/active-students/not-matched`,
                            )
                        }
                    />
                </Box>
            </PageContent>
        </Page>
    );
};

const SubCard = ({ label, value, onClick }) => (
    <Box
        pad="medium"
        elevation="small"
        round="small"
        align="center"
        gap="small"
        width="medium"
        onClick={onClick}
        focusIndicator={false}
        style={{ cursor: 'pointer' }}>
        <Text size="xxlarge" weight="bold">
            {value}
        </Text>
        <Text size="small" textAlign="center">
            {label}
        </Text>
    </Box>
);

const loadMatchedCurrentCount = async (schoolId) => {
    const query = QueryString.stringify({
        filters: {
            enrichProgramStatus: 'active',
            school: schoolId,
            candidacies: { job: { status: 'open' } },
        },
        pagination: { pageSize: 1 },
    });

    try {
        const response = await API.get(`/api/contacts?${query}`);
        return response.data.meta.pagination.total;
    } catch (error) {
        console.log(error);
        return 0;
    }
};

const loadMatchedFutureCount = async (schoolId) => {
    const query = QueryString.stringify({
        filters: {
            enrichProgramStatus: 'active',
            school: schoolId,
            candidacies: { job: { status: { $in: ['preparing', 'demo'] } } },
        },
        pagination: { pageSize: 1 },
    });

    try {
        const response = await API.get(`/api/contacts?${query}`);
        return response.data.meta.pagination.total;
    } catch (error) {
        console.log(error);
        return 0;
    }
};

const loadNotMatchedCount = async (schoolId) => {
    const query = QueryString.stringify({
        filters: {
            enrichProgramStatus: 'active',
            school: schoolId,
            candidacies: { id: { $null: true } },
        },
        pagination: { pageSize: 1 },
    });

    try {
        const response = await API.get(`/api/contacts?${query}`);
        return response.data.meta.pagination.total;
    } catch (error) {
        console.log(error);
        return 0;
    }
};
